import React, { useEffect, useState } from "react";
import api, { API } from "../lib/api";

export default function TrustedBy() {
  const [clients, setClients] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/clients")
      .then(({ data }) => setClients(data || []))
      .catch(() => setClients([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || !clients.length) return null;

  // Duplicate for seamless marquee loop
  const row = [...clients, ...clients];

  return (
    <div
      data-testid="trusted-bar"
      className="fixed left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-b border-black/10 shadow-[0_8px_24px_rgba(0,0,0,0.4)] overflow-hidden"
      style={{ top: "80px" }}
    >
      <div className="relative h-12 md:h-14 group">
        {/* Edge fade masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />

        <div
          className="marquee whitespace-nowrap h-full items-center"
          style={{ animationDuration: "70s" }}
        >
          {row.map((c, i) => (
            <div
              key={`${c.id}-${i}`}
              className="inline-flex items-center justify-center mx-5 md:mx-7 align-middle h-full"
              data-testid={`trusted-logo-${i}`}
            >
              <img
                src={`${API}/clients/${c.id}/logo`}
                alt={c.name}
                title={c.name}
                loading="lazy"
                decoding="async"
                className="h-7 md:h-8 w-auto max-w-[140px] md:max-w-[160px] object-contain transition-transform duration-300 hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
